import { redirect } from '@tanstack/react-router';
import type { ReleaseFlagType } from '../model/releaseFlag';
import { isReleaseFlagEnabled } from '../model/useReleaseFlag';

/**
 * beforeLoad でのみ使用する。リリースフラグをチェックし、無効なら 404 ページへリダイレクト
 */
export const requireReleaseFlag = (releaseFlagType: ReleaseFlagType) => {
  if (!isReleaseFlagEnabled(releaseFlagType)) {
    throw redirect({ to: '/404' });
  }
};
